module.exports = __webpack_public_path__ + "static/media/icon-enable2fa-verify.45095d3c.svg";